import { Component, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';
import { DataService } from 'src/app/shared/services/data.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { Util } from 'src/app/shared/utils/functions';
import { ServiceComponents } from '../../../components/service/serviceComponents.service';
import { Rutas } from 'src/app/models/rutas';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    subscription: Subscription;
    idIdioma: string = '';
    url: string = '';
    etiquetas = [];
    menuFooter = [];
    rutaTrabajando: Rutas;
    rutaInversionista: Rutas;

    constructor(
        private generalService: GeneralService,
        private serviceComponent: ServiceComponents,
        private dataService: DataService
    ) { }

    ngOnInit() {
        this.getLink();

    }
    async getLink() {
        this.dataService.currentUrl.subscribe(url => this.url = url);
        this.subscription = this.dataService.$idioma.subscribe(value => {
            this.idIdioma = value;
            this.etiquetasFooter();
        })
        const RUTAS = await this.serviceComponent.getLinks()
            .then(resRuta => {
                if (resRuta['codigo'] === 1) {
                    const RUTACLUB = resRuta['data'];
                    this.rutaTrabajando = new Rutas(RUTACLUB[3]);
                    this.rutaInversionista = new Rutas(RUTACLUB[4]);
                }
            });

        
    }

    async etiquetasFooter() {
        const idIdioma = await Util.getIdIdioma(this.idIdioma);
        this.generalService.etiquetasFooter(idIdioma)
            .subscribe(result => {
                if (result['codigo'] === 1) {
                    //console.log("Etiquetas: ");
                    //console.log(result['data']);
                    this.etiquetas = result['data'];
                    this.menuFooter = this.etiquetas;
                    this.dataService.changeFooterMenu(this.menuFooter);
                }
                if (result['codigo'] === 2) {

                }
                if (result['codigo'] === 3) {

                }
            })
    }
}
